import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  return (
    <Link 
      to={`/projects/${project.id}`} 
      className="project-card"
      style={{
        textDecoration: 'none',
        color: 'inherit',
        display: 'block',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-8px)';
        e.currentTarget.style.boxShadow = '0 12px 30px rgba(0, 0, 0, 0.15)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
      }}
    >
      <div style={{
        background: 'var(--white)',
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}>
        {/* Image Container */}
        <div style={{
          position: 'relative',
          width: '100%',
          paddingBottom: '66.67%', // 3:2 aspect ratio
          overflow: 'hidden',
          background: 'var(--secondary-light)'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '3rem',
            color: 'var(--accent-blue)'
          }}>
            <span className="material-icons" style={{fontSize: 'inherit'}}>image</span>
          </div>
          {/* Category Badge */}
          <div style={{
            position: 'absolute',
            top: '1rem',
            right: '1rem',
            background: 'var(--accent-blue)',
            color: 'var(--white)',
            padding: '0.5rem 1rem',
            borderRadius: '20px',
            fontSize: '0.85rem',
            fontWeight: 'bold',
            zIndex: 2
          }}>
            {project.category}
          </div>
        </div>

        {/* Content */}
        <div style={{
          padding: '1.5rem',
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}>
          <h3 style={{
            fontSize: '1.3rem',
            color: 'var(--accent-blue)',
            marginBottom: '0.5rem',
            lineHeight: '1.3'
          }}>
            {project.title}
          </h3>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            marginBottom: '0.75rem',
            color: 'var(--gray-600)',
            fontSize: '0.9rem'
          }}>
            <span className="material-icons" style={{fontSize: '1.1rem'}}>location_on</span>
            <span>{project.location}</span>
            <span style={{margin: '0 0.25rem'}}>•</span>
            <span>{project.year}</span>
          </div>

          <p style={{
            color: 'var(--gray-600)',
            fontSize: '0.95rem',
            lineHeight: '1.6',
            marginBottom: '1rem',
            flex: 1
          }}>
            {project.shortDescription}
          </p>

          {/* View Project Button */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: 'var(--accent2-red)',
            fontWeight: 'bold',
            fontSize: '0.95rem'
          }}>
            <span>View Project</span>
            <span className="material-icons" style={{fontSize: '1.2rem'}}>arrow_forward</span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProjectCard;

